import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import {
  BlockContainer,
  PageColumn,
  RTEWrapper,
  SplitPageWrapper,
  InnerNarrowBlockContainer,
  InnerNarrowBlockContentContainer,
} from "BaseComponents/Wrappers";
import { ContentWrapper } from "./TextContentWrapper";
import { GetTextColor } from "Helpers/ColorHelper";

export const TextBlock = ({
  Text,
  CenterContent,
  FullWidth,
  BackgroundColor,
  AlignContentLeft,
  NarrowText,
  PageCenterContent,
}) => {
  const { textColor } = GetTextColor(BackgroundColor);

  if (!Text) {
    return null;
  }

  const returnText = () => {
    return (
      <PageColumn
        centerContent={CenterContent}
        fullWidth={FullWidth}
        bgColor={`#${BackgroundColor || 'fff'}`}
        alignContentLeft={AlignContentLeft}
      >
        <ContentWrapper maxwidth={FullWidth ? "100%" : undefined}>
          <RTEWrapper
            color={textColor}
            dangerouslySetInnerHTML={{
              __html: Text,
            }}
          />
        </ContentWrapper>
      </PageColumn>
    );
  };

  const returnTextNarrow = () => {
    return (
      <InnerNarrowBlockContainer
        narrowText={NarrowText}
        centerContent={PageCenterContent}
        useSmall={true}
      >
        <InnerNarrowBlockContentContainer
          narrowText={NarrowText}
          useSmall={true}
        >
          <RTEWrapper
            color={textColor}
            dangerouslySetInnerHTML={{
              __html: Text,
            }}
          />
        </InnerNarrowBlockContentContainer>
      </InnerNarrowBlockContainer>
    );
  };

  return (
    <BlockContainer
      className="textBlock"
      bgColor={`#${BackgroundColor || 'fff'}`}
      narrowText={NarrowText}
    >
      <SplitPageWrapper
        centerContent={CenterContent}
        Padding={FullWidth ? "0 1rem" : undefined}
      >
        {NarrowText ? returnTextNarrow() : returnText()}
      </SplitPageWrapper>
    </BlockContainer>
  );
};

TextBlock.propTypes = {
  Text: PropTypes.string,
  CenterContent: PropTypes.bool,
  FullWidth: PropTypes.bool,
  BackgroundColor: PropTypes.string,
  AlignContentLeft: PropTypes.bool,
  NarrowText: PropTypes.bool,
  PageCenterContent: PropTypes.bool,
};
